module.exports = __webpack_public_path__ + "static/img/matrix5.8c64d697.png";